import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ccgl",
  "use": "icon-ccgl-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-ccgl\"><path fill=\"#fff\" fill-opacity=\".8\" fill-rule=\"evenodd\" d=\"M7.5 15h5v-.625L10 13.75l-2.5.625zm10.625-4.375-.442.442-1.86-1.909.377 7.92a1 1 0 0 1-.999 1.047H4.804a1 1 0 0 1-.998-1.053l.418-7.914-1.907 1.909s-.295-.177-.442-.325c-.129-.128 6.15-6.977 7.755-8.724.2-.217.54-.213.737.005zM15 8.384v8.49H5v-8.49l5-5z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol